import React, { PureComponent } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { RouterProps } from 'react-router';
import { UseModalDispatch, UseModalState } from '@lwtears/lwt-common-frontend/lib/Modal';
import withModal from '@lwtears/lwt-common-frontend/lib/Modal/withModal';
import CharacterSelector from '../components/CharacterLists/CharacterSelector';
import ApplicationIFrame from '../components/ApplicationFrame';
import LoadingScreen from '../components/@common/LoadingScreen/LoadingScreen';
import { createEvent } from 'api';
import { appendSessionToUrl, getLiteSession } from 'api/lite-session';
import { remCalc } from '../util/style-util';
import { white } from '../styles/style-constants';
import chalkboardBackground from 'assets/images/chalkboard-background.jpg';
import {
  AppNames,
  CharacterTypeSectionState,
  Locale,
  Resource,
  AppStoreState,
  Workbook
} from 'types';
import { selectCharacter, fetchCharacters } from 'state/modules/app';
import { toggleSlideoutMenu } from 'state/modules/ui/actions';
import withStyles from 'components/@layout/withStyles';

type Props = {
  charactersApp: string;
  items: CharacterTypeSectionState[];
  locale: Locale;
  selectedCharacter: {
    url: string;
    characterCase: string;
    character: string;
  };
  showLoadingScreen: boolean;
  currentWorkbook: Workbook;
  selectCharacter: (character: Resource) => void;
  toggleSlideoutMenu: (boolean) => void;
  fetchCharacters: (applicationId: string) => Array<Resource>;
  classes?: any;
} & RouterProps &
  UseModalDispatch &
  UseModalState;

class WetDryTry extends PureComponent<Props> {
  componentDidMount() {
    this.props.fetchCharacters('wdt');
  }

  handleClickItem = async (character: Resource) => {
    await this.props.selectCharacter(character);
    this.openModal();

    return createEvent('accessResource', {
      section: 'wdt',
      resourceId: character.id,
      resourceType: character.type.type
    });
  };

  openModal = async () => {
    const { selectedCharacter } = this.props;
    const {
      title,
      url: characterUrl,
      data: { aspectRatio, heightAdjust }
    }: any = selectedCharacter;

    const { sessionId } = await getLiteSession(AppNames.GSS);
    const url = appendSessionToUrl(characterUrl, sessionId);

    this.props.openDraggableModal({
      body: <ApplicationIFrame aspectRatio={aspectRatio} heightAdjust={heightAdjust} url={url} />,
      titleText: title
    });
  };

  render() {
    const {
      charactersApp,
      items,
      locale,
      showLoadingScreen,
      currentWorkbook,
      classes: { container, content, heading, listElement }
    } = this.props;

    return (
      <div className={container}>
        <LoadingScreen loading={showLoadingScreen} />
        <div className={content}>
          <CharacterSelector
            items={charactersApp === 'wdt' ? items : []}
            onClickItem={this.handleClickItem}
            styleOverrides={{ heading, listElement }}
            application={'WDT'}
            characterType={'UpperCase'}
            locale={locale}
            currentWorkbook={currentWorkbook}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: AppStoreState) => ({
  charactersApp: state.app.app,
  items: state.entity.characterswdt,
  locale: state.app.locale,
  selectedCharacter: state.app.character.selectedCharacter,
  showLoadingScreen: state.app.showLoadingScreen,
  currentWorkbook: state.app.currentWorkbook
});

const styles: any = {
  container: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    backgroundImage: `url(${chalkboardBackground})`,
    backgroundSize: 'cover',
    color: white
  },
  content: {
    flex: 1,
    padding: remCalc(26),
    overflowY: 'auto',
    display: 'flex',
    justifyContent: 'center'
  },
  heading: {
    color: white
  },
  listElement: {
    ':hover': {
      backgroundColor: 'rgba(0,0,0,0.5)'
    }
  }
};

export default compose(
  withStyles(styles),
  withModal,
  connect(mapStateToProps, {
    selectCharacter,
    toggleSlideoutMenu,
    fetchCharacters
  })
)(WetDryTry as any);
